/**
 * Created by Ning Jiang on 10/26/2018.
 */



require("pixi-particles");

import {AnimatedParticle, Emitter, OldEmitterConfig} from "pixi-particles";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { TimelineMax } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";

export class ParticleController {

    private readonly Mid:OldEmitterConfig =  {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 1,
            "end": 0,
            "minimumScaleMultiplier": 1.3
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 50,
            "end": 1,
            "minimumSpeedMultiplier": 15
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 100,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "rotationSpeed": {
            "min": -300,
            "max": 300
        },
        "lifetime": {
            "min": 1,
            "max": 2.5
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": 0.5,
        "maxParticles": 30,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "point"
    };

    private loopTl:TimelineMax | null;
    
    private _emitter:Emitter;
    private _timeName:string = "";

    private deltaTime:number = 0;
    
    private get elapsedTime():number{
        return TimeCheckPoints.getCheckPointTime(this._timeName);
    }

    private set timeName(name:string){
        this._timeName = name;
        TimeCheckPoints.setCheckPoint(name);
    }
    
    constructor(type:string, layer:PIXI.Container){
        this.timeName = type;
        this._emitter = new Emitter(layer, [{
            framerate : 30,
            loop : false,
            hasLoaded : true,
            textures : GameResources.getTextures(type)
        }], this.Mid);
        this._emitter.particleConstructor = AnimatedParticle;
        this._emitter.emit = false;
    }

    private update():void {
        this._emitter.update((this.elapsedTime - this.deltaTime)* 0.001)
        this.deltaTime = this.elapsedTime;
    }

    public enableEmit(value:boolean):void {
        if(value && !this.loopTl){
            this.loopTl = new TimelineMax({
                repeat:-1,
                onUpdate:() => this.update(),
                onRepeat:() => { if(this._emitter.particleCount == 0) this.loopTl = Helper.timeLineNuller(this.loopTl) }
            });
            this.loopTl.to(this,1,{});
            this.loopTl.play();
            this.deltaTime = this.elapsedTime;

        } 
        this._emitter.emit = value;
    }

    public setPos(newPos:PIXI.Point):void{
        this._emitter.spawnPos.copyFrom(newPos);
    }
}